import { Grid, TextField } from '@mui/material';
import styles from '../VisibilityDetailsV0/visibilityDetails.module.scss';
import Paper from '../../../components/Paper';


const CallOutDetails = ({ state, setters, handlers, validation, validationSetters }) => {
    return (
        <Paper heading="Step 4 -  Fill details ">
            <Grid container className={styles.visibilityDetailsContainer} justifyContent="space-between" alignItems="baseline">
                <Grid container item xs={3}>
                <Grid item xs={12} className={styles.label}>Product List Call-out<span className={styles.imp}>*</span></Grid>
                <Grid item xs={12}>
                    <TextField fullWidth size='small' type="text" value={state.plvCallOut} onChange={handlers.plvCallOut} error={!validation.plvCallOut.valid && validation.plvCallOut.touched} onBlur={validationSetters.plvCallOut.touched} />
                </Grid>
                </Grid>
                <Grid container item xs={3}>
                <Grid item xs={12} className={styles.label}>Campaign Score<span className={styles.imp}>*</span></Grid>
                <Grid item xs={12}>
                    <TextField fullWidth size='small' type="text" value={state.score} onChange={handlers.score} error={!validation.score.valid && validation.score.touched} onBlur={validationSetters.score.touched} />
                </Grid>
                </Grid>
                <Grid container item xs={4} />
            </Grid>
        </Paper>
    );
}

export default CallOutDetails;
